export default "__VITE_ASSET__d836a954__"